export const INTRO_CONTENT = {
  welcome: 'WELCOME TO THE',
  boothName: 'TYPE2 VIRTUAL EXPERIENCE',
  loadingMessage: 'LOADING, PLEASE WAIT',
}
